import { StateCreator } from "zustand";
import { LexicalEditor } from "lexical";

export interface EditorSlice {
  editorInstance: LexicalEditor | null;
  setEditorInstance: (editor: LexicalEditor | null) => void;
}

const createEditorSlice: StateCreator<EditorSlice, [], [], EditorSlice> = (set) => ({
  editorInstance: null,
  setEditorInstance: (editor: LexicalEditor | null) => set({ editorInstance: editor }),
});

export default createEditorSlice;
